export default __webpack_public_path__ + "static/media/forecast-analytics.8cbd306d.png";